import { Stack } from 'libs/ui/Stack';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const ContentStyled = styled(Stack)(() => ({
  gap: 12,
  padding: 16,

  '&:hover': {
    '.notificationItem-checkBox': {
      display: 'flex',
    } as CSSObject,
    '.notificationItem-readMark': {
      display: 'none',
    } as CSSObject,
  } as CSSObject,

  '.notificationItem-checkBox': {
    width: 24,
    height: 24,
    borderRadius: 4,
    alignItems: 'center',
    backgroundColor: Colors.blue100,
    justifyContent: 'center',
    display: 'none',

    '& svg path': {
      strokeWidth: 1,
    } as CSSObject,
  } as CSSObject,

  '.notificationItem-readMark': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: Colors.blue500,
  } as CSSObject,
}));
